import { currencyColumn, dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn, textColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'default';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    textColumn({column: 'name', label: 'Name', required: true}),
    textColumn({column: 'description', label: 'Description', required: true}),
    currencyColumn({column: 'value', required: true}),
    relationshipColumn({column: 'grant_category_id', endpoint: 'grant-categories', label: 'Category', loadAll: true, required: true, hydrate: false}),
    dateColumn({column: 'applied_date', label: 'Applied', required: true}),
    dateColumn({column: 'awarded_date', label: 'Awarded', required: true}),
];

const GrantsReceived = forwardRef(function GrantsReceived(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {GrantsReceived};
